// Sobrevivencia da credencial do cliente no aparelho dele.
//
// O token do AppCel vale 30 dias e e' RENOVADO a cada abertura (`GET /api/app/me`
// devolve um token novo), entao pelo nosso lado nao existe "pedir senha de novo":
// quem abre o app uma vez por mes nunca mais digita nada. Quem encerra a sessao e'
// o cliente trocando a senha, a loja revogando, ou o NAVEGADOR jogando fora o
// `localStorage` onde o token mora.
//
// O terceiro caso e' o unico que ainda mordia, e ele tem duas causas distintas —
// nao confundir, porque a defesa de uma nao cobre a outra:
//
//  1. **ITP (Safari): 7 dias.** "ITP deletes all cookies created in JavaScript and
//     all other script-writeable storage after 7 days of no user interaction with
//     the website" (webkit.org/tracking-prevention). Nao e' calendario — sao 7 dias
//     de USO DO SAFARI sem o site ser aberto; iPhone na gaveta nao queima o prazo.
//     Leva junto o registro do service worker, ou seja mata a notificacao no mesmo
//     ato. ⛔ **`persist()` NAO defende disto.** Quem defende e' o atalho na tela de
//     inicio: a WebKit tem secao propria ("Home Screen Web Application Domain Exempt
//     From ITP") dizendo que o dominio de web app instalado e' pulado pelo algoritmo
//     de remocao, e que apagar ali seria "a serious bug".
//  2. **Despejo por espaco (iOS 17+ / Safari 17).** Separado do ITP: acontece por
//     cota estourada ou aparelho sem espaco. Contra ESTE a defesa oficial e' o modo
//     persistente, e a WebKit diz conceder "based on heuristics like whether the
//     website is opened as a Home Screen Web App"
//     (webkit.org/blog/14403/updates-to-storage-policy/).
//
// ⚠️ Nenhuma fonte oficial promete sobrevivencia eterna do `localStorage`. O que a
// fonte garante e' que ele nao morre por DECURSO DE PRAZO com o app instalado.

import { estaInstalado } from './push';

/**
 * Pede modo persistente pro armazenamento do app.
 *
 * ⛔ **So com o app INSTALADO, e o gate nao e' zelo.** Em aba, dois motivos: (a) o
 * cliente em aba perde a credencial pro ITP de qualquer jeito, e `persist()` nao
 * cobre aquilo — concedido ali, o modo persistente daria uma falsa sensacao de
 * resolvido; (b) navegador que trata isto como PERMISSAO (Firefox) abre uma janela
 * perguntando, e quem acabou de chegar pelo link do convite levaria uma pergunta
 * que nao sabe responder, antes mesmo de ver a loja. Instalado, ninguem pergunta
 * nada e a heuristica da WebKit joga a favor.
 *
 * Silencioso de proposito: e' melhoria de durabilidade, nao funcionalidade. Falhar
 * aqui nao pode virar erro na tela de quem so quer conversar com a loja.
 */
export async function garantirPersistencia(): Promise<void> {
  try {
    if (!estaInstalado()) return;
    if (!navigator.storage?.persist || !navigator.storage?.persisted) return;
    if (await navigator.storage.persisted()) return;
    await navigator.storage.persist();
  } catch {
    /* durabilidade e' bonus: nunca atrapalhar o uso do app */
  }
}
